export default "__VITE_ASSET__DjE_O4Fh__"